import { EntityType } from '@neptune/shared/entity-domain';
import type { Widget, WidgetDefinitionNew } from '@neptune/shared/widgets-domain';

import { AttributeDefinition } from 'domain/experiment/attribute';
import { WidgetDefinition } from 'domain/widget/core/domain/widget-definition';

import { HistogramWidgetOptions } from './histogram-configuration';

export const HISTOGRAM_WIDGET_DEFINITION_METADATA: WidgetDefinitionNew = {
  widgetType: 'histogram',
  label: 'Histogram',
  description: 'Visualize distributions across steps',
  icon: 'histogram',
  dataItem: 'histogram',
  hasSettings: true,
};

export type HistogramWidget = Widget & {
  type: 'histogram';
  options: HistogramWidgetOptions;
};

export function isHistogramWidget(widget: Widget): widget is HistogramWidget {
  return widget.type === 'histogram';
}

export type HistogramSource = {
  attributes: AttributeDefinition[];
  entityShortId: string;
  entityId: string;
  entityType: EntityType;
  projectIdentifier: string;
  lineageEntityType: 'RUN' | 'EXPERIMENT';
};

export function histogramWidgetOptionsFromApiToDomain(
  options?: Record<string, any>,
): HistogramWidgetOptions {
  return {
    xAxisMode: options?.xAxisMode ?? 'step',
    xAxisScale: options?.xAxisScale ?? 'linear',
    xAxisRange: options?.xAxisRange,
    yAxisRange: options?.yAxisRange,
    xAxisMetric: options?.xAxisMetric,
  };
}

export const histogramWidgetDefinition: WidgetDefinition = {
  type: 'histogram',
  fromApiToDomain: histogramWidgetOptionsFromApiToDomain,
};
